export default __webpack_public_path__ + "static/stars_2-0b3a1f7ffbefb3817643c23e1a79cf42.png";